import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { isPlatformAdmin, userHasFeature } from '../constants/features';

export function useFeatureAccess() {
  const { user } = useAuth();
  const permissions = user?.permissions || [];

  const hasFeature = useMemo(
    () => (feature) => isPlatformAdmin(user?.role) || userHasFeature(permissions, feature),
    [user?.role, permissions]
  );

  const hasAnyToolAccess = useMemo(() => {
    if (isPlatformAdmin(user?.role)) return true;
    return Array.isArray(permissions) && permissions.length > 0;
  }, [user?.role, permissions]);

  const hasActiveStores = useMemo(() => {
    if (isPlatformAdmin(user?.role)) return true;
    return Array.isArray(user?.toolProfileAccess) && user.toolProfileAccess.length > 0;
  }, [user?.role, user?.toolProfileAccess]);

  return {
    permissions,
    hasFeature,
    hasAnyToolAccess,
    hasActiveStores,
    isAdmin: isPlatformAdmin(user?.role),
  };
}
